module.exports = require('./lib/client')



//////////////////
// WEBPACK FOOTER
// ./~/hubspot/index.js
// module id = jqfK
// module chunks = 1